<template>
    <div class="submit-main">
        <van-sticky
            type="primary"
            v-if="isWechat"
        >
            <van-nav-bar
                title="确认订单"
                left-text="返回"
                left-arrow
                @click-left="onGoBack"
            />
        </van-sticky>
        <!-- 订单信息 -->
        <cell-card>
            <div class="submit__order-info-wrapper">
                <!-- 店铺名 -->
                <van-row class="submit__order-info-shop-wrapper" type="flex" align="bottom" gutter="1">
                    <van-col class="submit__order-info-shop-icon-wrapper">
                        <van-icon class="submit__order-info-shop-icon" size="16" name="shop-o" />
                    </van-col>
                    <span class="submit__order-info-shop">海藻票务</span>
                </van-row>
                <!-- 商品信息 -->
                <van-row class="submit__goods-wrapper" type="flex">
                    <!-- 商品头图 -->
                    <van-col class="submit__goods-avatar-wrapper">
                        <van-image class="ac-main__image" :src="coverPic" width="72" height="72"/>
                    </van-col>
                    <!-- 商品详细信息 -->
                    <van-col class="submit__goods-info-wrapper">
                        <van-row class="submit__goods-info-title">{{skuName}}</van-row>
                        <van-row class="submit__goods-info-num">x {{num}}</van-row>
                        <van-row class="submit__goods-info-price">¥ {{skuPriceYuan}}</van-row>
                    </van-col>
                </van-row>
                <!-- 优惠券码 -->
                <van-row class="submit__coupon-wrapper">
                    <van-coupon-cell
                        :coupons="couponAvailable"
                        :chosen-coupon="chosenCoupon"
                        @click="showList = true"
                    />
                </van-row>
            </div>
        </cell-card>
        <!-- 温馨提示 -->
        <cell-card
            class="submit__sweet-tip-wrapper"
            title="温馨提示"
        >
            <div class="submit__sweet-tip-content" v-html="instruction"/>
        </cell-card>
        <!-- placeholder -->
        <div class="submit__bar-placerholder"/>
        <!-- 确认提交按钮 -->
        <van-submit-bar
            class="submit__bar-action"
            :price="orderPrice"
            :loading="loading"
            button-text="提交订单"
            @submit="onSubmit"
        />
        <!-- 优惠券列表 -->
        <van-popup
            v-model="showList"
            round
            position="bottom"
            style="height: 90%; padding-top: 4px;"
        >
            <van-coupon-list
                :coupons="couponAvailable"
                :disabled-coupons="couponDisable"
                :chosen-coupon="chosenCoupon"
                @change="onChange"
                @exchange="onExchange"
            />
        </van-popup>
    </div> 
</template>

<script>
import CellCard from "@/components/CellCard.vue";
import {Col, Row, Icon, CouponCell,
    CouponList, Popup, SubmitBar, Image, NavBar, Sticky} from "vant";
import request from "@/utils/request.js";
import {navMixins, wechatMixins} from "@/mixins.js";
import wechat from "@/utils/wechat.js";

function couponNameMap(coupon) {
    switch(coupon.couponType) {
        case 'GOODS':
            return "商品抵扣券";
        case 'MONEY':
            return "金额抵扣券";
        case 'DISCOUNT':
            return "打折券";
    }
}

function descMap(coupon) {
    switch(coupon.couponType) {
        case 'GOODS':
            return "可直接兑换一件目标商品";
        case 'MONEY':
            return "抵扣目标商品一定金额";
        case 'DISCOUNT':
            return "目标商品折扣销售";
    }
}

function couponPriceValueMap(coupon) {
    switch(coupon.couponType) {
        case 'GOODS':
            return coupon.effectData;
        case 'MONEY':
        case 'DISCOUNT':
            return (coupon.effectData / 100).toFixed(2);
    }
}

function couponUnitMap(coupon) {
    switch(coupon.couponType) {
        case 'GOODS':
            return "件";
        case "MONEY":
            return "元";
        case "DISCOUNT":
            return "折";
    }
}

function useConditionMap(coupon) {

    if (coupon.skuCode) {
        return `限商品使用\n【${coupon.skuName}】`;
    }
    if (coupon.minCost) {
        return `最低消费${(coupon.minCost / 100).toFixed(2)}元`;
    }
    return "无限制条件";
}

export default {
    name: 'SubmitOrder',
    mixins: [navMixins, wechatMixins],
    components: {
        [CellCard.name]: CellCard,
        [Row.name]: Row,
        [Col.name]: Col,
        [Icon.name]: Icon,
        [CouponCell.name]: CouponCell,
        [CouponList.name]: CouponList,
        [Popup.name]: Popup,
        [SubmitBar.name]: SubmitBar,
        [Image.name]: Image,
        [NavBar.name]: NavBar,
        [Sticky.name]: Sticky
    },
    data() {
        return {
            showList: false,

            chosenCoupon: -1,
            coupons: [],
            disabledCoupons: [],

            loading: false,

            skuCode: undefined,
            skuName: "",
            num: 1,
            skuPrice: 0,
            coverPic: "",
            instruction: ""
        };
    },
    computed: {
        skuPriceYuan() {
            if (this.skuPrice) {
                return (this.skuPrice / 100).toFixed(2);
            }
            return this.skuPrice;
        },
        orderPrice() {
            if (this.skuPrice) {
                if (this.chosenCoupon >= 0) {
                    const deductPrice = this.couponAvailable[this.chosenCoupon].value;
                    return this.skuPrice * this.num - deductPrice;
                }
                return this.skuPrice * this.num;
            }
            return 0;
        },
        couponAvailable() {
            if (this.coupons) {
                const tmpCoupons = this.coupons.map(coupon => {
                    return {
                        id: coupon.couponNo,
                        name: couponNameMap(coupon),
                        condition: useConditionMap(coupon),
                        startAt: new Date(coupon.validStartTime).getTime() / 1000,
                        endAt: new Date(coupon.validEndTime).getTime() / 1000,
                        description: descMap(coupon),
                        valueDesc: couponPriceValueMap(coupon),
                        value: this.couponPriceMap(coupon),
                        unitDesc: couponUnitMap(coupon)
                    };
                });
                return tmpCoupons;
            }
            return [];
        },
        couponDisable() {
            if (this.disabledCoupons) {
                const tmpCoupons = this.disabledCoupons.map(coupon => {
                    return {
                        id: coupon.couponNo,
                        name: couponNameMap(coupon),
                        condition: useConditionMap(coupon),
                        startAt: new Date(coupon.validStartTime).getTime() / 1000,
                        endAt: new Date(coupon.validEndTime).getTime() / 1000,
                        valueDesc: couponPriceValueMap(coupon),
                        value: this.couponPriceMap(coupon),
                        unitDesc: couponUnitMap(coupon),
                        reason: coupon.reason
                    };
                });
                return tmpCoupons;
            }
            return [];
        }
    },
    mounted() {
        this.skuCode = this.$route.query.skuCode;
        this.num = this.$route.query.num;
        this.loadSubmitOrderInfo();
    },
    methods: {
        couponPriceMap(coupon) {
            switch(coupon.couponType) {
                case 'GOODS':
                    // 直接扣掉一个商品的价格
                    return this.skuPrice;
                case 'MONEY':
                    return coupon.effectData;
                case 'DISCOUNT':
                    // 折扣券，折扣订单下所有商品，还是一个商品？
                    return (coupon.effectData * this.skuPrice * this.num).toFixed(2);
            }
        },
        async loadSubmitOrderInfo() {
            const {response, data} = await request.post('/customer/order/loadSubmitOrderInfo', {
                data: {
                    skuCode: this.skuCode,
                    num: this.num
                }
            });
            if (response.ok) {
                this.skuPrice = data.skuPrice;
                this.skuName = data.skuName;
                this.coverPic = data.coverPic;
                this.instruction = data.instruction;
                this.coupons = data.coupon && data.coupon.available ? data.coupon.available : [];
                this.disabledCoupons = data.coupon && data.coupon.disable ? data.coupon.disable : [];
            }
        },
        onChange(index) {
            this.showList = false;
            this.chosenCoupon = index;
        },
        onExchange(code) {
            console.log(code)
            // this.coupons.push(coupon);
        },
        async onSubmit() {
            this.loading = true;
            // 创建订单
            let couponNo;
            if (this.chosenCoupon >= 0 && this.couponAvailable) {
                couponNo = this.couponAvailable[this.chosenCoupon].id;
            }
            try {
                const orderResult = await request.post('/customer/order/createOrder', {
                    data: {
                        orderPrice: this.orderPrice,
                        itemList: [{
                            skuCode: this.skuCode,
                            count: this.num,
                            skuPrice: this.skuPrice,
                            couponNo
                        }]
                    }
                });
                // 创建支付单
                const orderNo = orderResult.data.orderNo;

                const {data} = await request.post('/customer/payment/createPayOrder', {
                    data: {
                        orderNo,
                        payType: this.orderPrice == 0 ? "ZERO" : "WECHAT_JSAPI"
                    }
                });
                if (this.orderPrice != 0) {
                    const paymentParam = JSON.parse(data.paymentParam);
                    // 拉起Wap支付
                    wechat.triggerWapPayment(paymentParam.appId,
                                            paymentParam.timeStamp,
                                            paymentParam.nonceStr,
                                            paymentParam.package,
                                            paymentParam.signType,
                                            paymentParam.paySign, () => {
                                                this.$router.push(`/result/${orderNo}`);
                                            });
                } else {
                   this.$router.push(`/result/${orderNo}`); 
                }

            } finally {
                this.loading = false;
            }
        }
    }
}
</script>

<style lang="less">
@import "@/style/base.less";
.submit-main {
    .van-coupon-list__bottom {
        padding-bottom: env(safe-area-inset-bottom);
        padding-bottom: constant(safe-area-inset-bottom);
    }

    p.van-coupon__description {
        margin-block-start: 0px;
        margin-block-end: 0px;
    }

    .van-tabs__line {
        background-color: @color-theme;
    }
    // 卡券底部按钮
    .van-coupon-list__bottom .van-button--danger {
        background-color: @color-theme;
        border: 1px solid @color-theme;
        color: @color-vice-font;
    }

    // 卡券兑换按钮
    .van-coupon-list__exchange-bar .van-button--danger{
        color: @color-theme;
    }
}
.submit__order-info-wrapper {
    padding: 8px;
}

.submit__order-info-shop-wrapper {
    margin-left: 8px;
}
.submit__order-info-shop-icon-wrapper {
}

.submit__order-info-shop-icon {
    vertical-align: middle;
}

.submit__order-info-shop {
    font-size: @font-size-normal;
    line-height: @line-height-normal;
    color: @font-color-normal;
    font-weight: @font-weight-normal;
}
.submit__goods-wrapper {
    margin: 8px;
}

.submit__goods-info-wrapper {
    flex-grow: 1;
    margin-left: 16px;
}
.submit__goods-info-title {
    font-size: @font-size-title;
    color: @font-color-title;
    font-weight: @font-weight-title;
    line-height: @line-height-title;
}
.submit__goods-info-num {
    text-align: right;
}

.submit__coupon-wrapper {
    .van-cell {
        padding: 10px 8px;
    }
}

.submit__sweet-tip-content {
    padding: 0 16px 16px 16px;
}
.submit__bar-placerholder {
    padding-bottom: calc(58px + env(safe-area-inset-bottom));
    padding-bottom: calc(58px + constant(safe-area-inset-bottom));
}

.submit__bar-action {
    .van-submit-bar__button--danger {
        background: @color-theme;
        color: @color-vice;
    }

    .van-submit-bar__price {
        font-weight: @font-weight-price;
    }
}
</style>